import React from 'react';
import styled from 'styled-components';
import { FilterList } from '../Common/FilterList';
import { LabelItem } from '../Common/LabelItem';
import { ServiceStaffResponse, serviceStaffMobile } from './serviceStaff';
import { isErrorMobile, isErrorMobile100 } from '@/component/PageComponentMobile/error';


const FilterStaffMobileView = styled.div`




`


export interface FilterStaffMobileProps {
  onChange:(value:any[])=>void
  value:any[]
}



export const FilterStaffMobile = (props:FilterStaffMobileProps)=>{
  // const {} = useSearchCondition({staff:['branch']})
  const [staff,setStaff] = React.useState<ServiceStaffResponse['data']['staff']>([])
  const [visible,setVisible] = React.useState(false)
  const [loading,setLoading] = React.useState(false)
  const getStaff = async ()=>{
    setLoading(true)
    let res = await serviceStaffMobile()
    setLoading(false)
    if(isErrorMobile100(res)){
      return
    }
    setStaff(res.data.data.staff)
  }
  React.useEffect(()=>{
    if(visible && !staff.length){
      getStaff()
    }
  },[visible])
  let options = React.useMemo(()=>{
    return staff.map(item=>({label: item.name,value: item.value})) 
  },[staff])
  return <FilterStaffMobileView>
    <LabelItem
      label='业务员'
      options={options}
      value={props.value}
      onClick={()=>setVisible(pre=> !pre)}
    />
    <FilterList
      loading={loading}
      dataSource={ options }
      visible={visible}
      value={props.value}
      headerText='选择业务员'
      onChange={(value)=>{
        props.onChange(value)
      }}
      onClose={()=>setVisible(false)}
    />

  </FilterStaffMobileView>
} 



